import Api from "utils/api/Api"
export const getReadingPictureList = (params)=>{
    const requestData = params?.queryKey[1];
    return Api.post(`/api/picture/list?page=${requestData.page}&size=${requestData.size===undefined?5:requestData.size}`, requestData);
}

export const apiDeleteReadingPicture = (id)=> Api.get(`/api/picture/${id}/delete`);

// 임시저장
export const apiStorePictureTemp = (data)=>Api.post('/api/picture/temp/store', data);
export const apiGetPictureTemp = (params)=>Api.get(`/api/picture/temp/${params?.queryKey[1]}`);



// 인기도서
export const apiReadingPicturePopular = ()=>Api.get('/api/picture/popular/books/picture');
export const apiReadingPhotoPopular = ()=>Api.get('/api/picture/popular/books/photo');

// 저장
export const apiStorePicture = (data)=>Api.post(`/api/picture/store`, data);


export const apiStorePhoto = (requestData = {data:null, onUploadProgress:f=>f})=>{
    return Api.post(`/api/picture/store/photo`, requestData.data, {
        headers:{
            "X-Requested-With": "XMLHttpRequest",
            'Content-Type': "multipart/form-data"
        },
        onUploadProgress: requestData.onUploadProgress
    });
};

